var map = {
	"./img_1.png": 14961,
	"./img_2.png": 29321,
	"./img_3.png": 14152,
	"./img_4.png": 27619,
	"./img_5.png": 36298,
	"./img_6.png": 7073,
	"./img_7.png": 20387
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89255;